seedWebApp.controller('DashboardController', ['$scope', '$rootScope', '$window', '$route', '$routeParams', '$location', 'ContactService', 'StoreService', 'ToastService',
    function ($scope, $rootScope, $window, $route,$routeParams, $location, ContactService, StoreService, ToastService) {
        console.log('dashboardController');

        $scope.today = new Date();
        $scope.filterString = '';

        $scope.selectedIndex = $routeParams.Tab;
        $scope.tabSelected = function (pageIndex) {
            $location.search('Tab', pageIndex);
            $scope.selectedIndex = pageIndex;
        };

        $scope.getContacts = function () {
            $scope.loadingTotal = true;
            ContactService.getContacts($scope.filterString, $scope.options, 0, 2000).then(function (response) {
                $scope.loadingTotal = false;
                if (response) {
                    $scope.items = response.data;
                }

            });
        };

        //$scope.getContacts();

        $scope.getImage = function (country) {
            return '/Images/flags/' + country + '.png';
        };

        $scope.openDetail = function (item, ev) {
            console.log('Dashboard.openDetail');
            var modalInstance = StoreService.openOrderDetailModal(item.OrderID);
            modalInstance.result.then(function (order) {
                if (order && order.StatusID) {
                    item.StatusID = order.StatusID;
                }
            });
        };

        $scope.loadEmptyContainers = function (contactID) {
            console.log('loadQuotes');

            var searchString = '';
            StoreService.getEmptyContainers(contactID, searchString)
                .then(function (result) {
                    $scope.loading = false;
                    //$scope.quotes = $scope.getQuotes(result.data.items);
                    //$scope.preSales = $scope.getPreSales(result.data.items);
                    $scope.preSales = result.data.items;
                    //$scope.groupQuotes($scope.quotes);
                })
                .catch(function (errorDescription) {
                    $scope.loading = false;
                    $scope.error = true;
                    $scope.errorDescription = errorDescription;
                    ToastService.createToast('Erro ao carregar itens', '', 8000, 'error');
                });
        };

        //$scope.getQuotes = function (orders) {
        //    var quotes = orders.filter(function (order) {
        //        return StoreService.isQuote(order);
        //    });
        //    return quotes;
        //};

        //$scope.getPreSales = function (orders) {
        //    var quotes = orders.filter(function (order) {
        //        return !StoreService.isQuote(order) && !order.Quote;
        //    });
        //    return quotes;
        //};

        //$scope.groupQuotes = function (quotes) {
        //    var numPreSales = quotes.reduce(function (total, quote) {
        //        if (!StoreService.isQuote(quote)) {
        //            return total + 1
        //        }
        //        else {
        //            return total;
        //        }
        //    }, 0);
        //    console.log('numPreSales ' + numPreSales);
        //    //numPreSales = 0;
        //    for (var i in quotes) {
        //    }
        //};

        $scope.doRefresh = function () {
            console.log('dashboard.doRefresh');
            StoreService.resetCache();
            $scope.getContacts();
            $scope.loadEmptyContainers('');            
        };

        $scope.doRefresh();

        $scope.importOrders = function () {
            ToastService.createToast('Importando Pedidos', '', 4000, 'wait');            
            StoreService.startIntegrationShipping().then(
                function (response) {
                    console.log('Importacao iniciada');
                    var scopeID = response.data.scopeID;
                    ToastService.createToast('Importação iniciada', scopeID, 2000, 'success');
                },
                function (err) {
                    var errMsg = '';
                    if (err.data && err.data.ExceptionMessage) {
                        errMsg = err.data.ExceptionMessage;
                    }
                    ToastService.createToast('Erro', errMsg, 8000, 'error');
                }
            );            
        };

        $(document).ready(function () {            
            $scope.overflowSize = $scope.AdjustSize();
            console.log('document.ready.AdjustSize ' + $scope.overflowSize);
        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize();
        };

    }]
);
